import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_BUYER } from './queries';
import { ButtonContainer } from './elements';

const NewBuyer = props => {
  const {
    setShowModal, refetch, buyerName, saleAssetId, updateSaleAsset
  } = props;

  const [submitting, setSubmitting] = useState();
  const [createBuyer] = useMutation(CREATE_BUYER, {
    onCompleted: data => {
      if (refetch) { refetch(); }

      if (updateSaleAsset) {
        updateSaleAsset({
          variables: {
            id: saleAssetId,
            offerAttributes: { buyerId: data.createBuyer.buyer.id }
          }
        });
      }

      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createBuyer({ variables: input });
  });

  const {
    control, register, handleSubmit, watch, formState: { errors }
  } = useForm({
    defaultValues: {
      name: buyerName || '',
      companyName: '',
      street: '',
      city: '',
      state: '',
      postalCode: '',
      phoneNumber: '',
      email: '',
      publicAuctionBuyer: false,
    }
  });

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Company Name:"
            hint="At least one of name or company name is required."
            name="companyName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Street:"
            name="street"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="City:"
            name="city"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Zip:"
            name="postalCode"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
          />
          <Input.Switch
            label="Is this a Buyer from a Public Auction?"
            name="publicAuctionBuyer"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Buyer" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewBuyer;
